// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__1P5Np","errorLogs":"EditorFooter_errorLogs__1RrN3"};